import { styled } from '../jss-style';
import datePickerStyle from './date-picker';

const useDatePickerStyle = styled(datePickerStyle, 'datePicker');
export { datePickerStyle, useDatePickerStyle };
export default useDatePickerStyle;
